import PropTypes from 'prop-types'
import React from 'react'
import { color } from 'ui/variables'
import Animation from './Animation'
import ShowHide from './ShowHide'
import './Status.css'

const Status = props => (
  <div className='Status'>
    <ShowHide show={props.showIndicator}>
      <Animation type={props.shouldAnimate ? 'flash' : false}>
        <svg width='8px' height='8px'>
          <circle fill={props.indicatorColor} cx='4' cy='4' r='4' />
        </svg>
      </Animation>
    </ShowHide>
    <ShowHide show={props.label}>
      <div className='Status--label' style={{ color: props.labelColor }}>{props.label}</div>
    </ShowHide>
  </div>
)

Status.defaultProps = {
  labelColor: color.grey[300],
  indicatorColor: color.grey[300]
}

Status.displayName = 'Status'

Status.propTypes = {
  indicatorColor: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelColor: PropTypes.string.isRequired,
  shouldAnimate: PropTypes.bool,
  showIndicator: PropTypes.bool.isRequired
}

export default Status



// WEBPACK FOOTER //
// ./ui/Status.js